import { Component, Input } from '@angular/core';

/**
 * Generated class for the RmtEmptyPickerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-empty-picker',
  templateUrl: 'rmt-empty-picker.html'
})
export class RmtEmptyPickerComponent {

  @Input() heading: string;
  @Input() placeholder: string;
  @Input() text: string;
  @Input() iconName: string;
  @Input() disabled:boolean;
  @Input() onClick;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/components/rmt-empty-picker/rmt-empty-picker.ts